/*import React, { useState } from 'react';
import {FaLocationDot} from "react-icons/fa6";
import {filterOptions} from "../data";
import {FaChevronCircleDown} from "react-icons/fa";
import "./Hero.css";
import { useNavigate,  Link } from 'react-router-dom';


const Hero = ({style}) => {

  const [activeButton, setActivButton] =useState("buy")
  const [openFilter, setopenFilter] = useState(null)
  const [selectedOptions, setSelectedOptions] = useState(
    filterOptions.map((filter) => filter.options[0])
  )

  const handleButtonClick = (buttonType)  =>{
    setActivButton(buttonType)
  };

  const handleFilterClick = (index) =>{
    setopenFilter(openFilter === index ? null : index)
  };

  const handleOptionSelect = (filterIndex,option) => {
    const updateOptions =  [...selectedOptions]
    updateOptions[filterIndex] = option
    setSelectedOptions(updateOptions)
    setopenFilter(null)
  };

  const navigate =useNavigate()
  const handleNavigate = () =>{
    navigate("/property");
  }


  return (
 
    <div className='hero' style={style}>
    <div className='hero-container'>
      <h1>دعنا نجد منزلك المثالي مع عقاري</h1>
      <p>جعل البحث عن منزلك سهلاً وممتعًا</p>
      <h1>يبدأ الأشخاص الذين يبحثون عن شراء أو استئجار أو الاستثمار في العقارات في جميع أنحاء المملكة العربية السعودية رحلتهم على موقعي العقاري - المصمم للبحث الذكي والاستثمار الاستراتيجي</h1>

     

<div className='buttons-container'>
  <Link to="https://salla.sa/akari.sa">
    <button className={activeButton === "buy" ? "active" : ""} onClick={() => handleButtonClick("buy")}>
    متجر على الإنترنت
    </button>
  </Link>

  <Link to="/saleproperty">
    <button className={activeButton === "sale" ? "active" : ""} onClick={() => handleButtonClick("sale")}>
    عقارات للبيع
    </button>
  </Link>
</div>




          </div>
        </div>
     
    
  
  )
}

export default Hero;
*/

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { filterOptions } from '../data';
import './Hero.css';
import bg from '../assets/bg-5.jpg'

const Hero = ({ style }) => {
  const [activeButton, setActiveButton] = useState('buy');
  const [openFilter, setOpenFilter] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState(
    filterOptions.map((filter) => filter.options[0])
  );

  const handleButtonClick = (buttonType) => {
    setActiveButton(buttonType);
  };

  const handleFilterClick = (index) => {
    setOpenFilter(openFilter === index ? null : index);
  };

  const handleOptionSelect = (filterIndex, option) => {
    const updateOptions = [...selectedOptions];
    updateOptions[filterIndex] = option;
    setSelectedOptions(updateOptions);
    setOpenFilter(null);
  };

  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate('/property');
  };

  return (
    <div className="hero" style={style}>
    <img src={bg} alt="logo-img" className='bg-img' />
      <div className="hero-overlay">
        <div className="hero-container">
          <h1>دعنا نجد منزلك المثالي مع عقاري</h1>
          <p>جعل البحث عن منزلك سهلاً وممتعًا</p>
          <p className="sub-text">
            يبدأ الأشخاص الذين يبحثون عن شراء أو استئجار أو الاستثمار في العقارات في جميع أنحاء المملكة العربية السعودية رحلتهم على موقعي العقاري - المصمم للبحث الذكي والاستثمار الاستراتيجي
          </p>

          <div className="buttons-container">
            <Link to="https://salla.sa/akari.sa">
              <button
                className={activeButton === 'buy' ? 'active' : ''}
                onClick={() => handleButtonClick('buy')}
              >
                متجر على الإنترنت
              </button>
            </Link>

            <Link to="/saleproperty">
              <button
                className={activeButton === 'sale' ? 'active' : ''}
                onClick={() => handleButtonClick('sale')}
              >
                عقارات للبيع
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
